<template>
    <div class="emailmo">
		<Nav ref="Nav" />
        <div class="writing_right">
            <div class="TitleList">
                <div class="TitleList_padding">
                    <div class="TitleList_top">
                        <div class="TitleList_top_title"><span></span>手机号修改</div>
                        
                    </div>
                </div>

                <div class="emailmo_step">
                            <div class="emailmo_step_list on">
                                <div class="step_list_icon">1</div>
                                <div class="step_list_title">验证身份</div>
                            </div>
                            <span></span>
                            <div class="emailmo_step_list on">
                                <div class="step_list_icon">2</div>
                                <div class="step_list_title">修改手机号</div>
                            </div>
                            <span></span>
                            <div class="emailmo_step_list on">
                                <div class="step_list_icon">3</div>
                                <div class="step_list_title">完成</div>
                            </div>
                        </div>

                <div class="emailms_content">
                    <div class="emailms_content_icon" style="background: #3662eb"><i class="el-icon-check"></i></div>
                    <div class="emailms_content_title">
                        <div class="content_title_dd">操作成功</div>
                        <!-- <div class="content_title_dt">提交结果页用于反馈一系列操作任务的处理结果，如果仅是简单操作，灰色区域可以显示一些补充的信息。</div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import Nav from "@c/common/nav/nav";

    export default {
        name: "mobileStepThree",
        data() {
            return {

            };
        },
        components: {
            Nav
        },
        methods:{

        },
        mounted() {
          let that = this;
          that.axios.get('/api/member/getInfo').then(res => {
            localStorage.setItem('memberInfo', JSON.stringify(res.result) )
            that.$store.commit('setMemberInfo', res.result)
            setTimeout(function(){
              window.location.href = '/#/memberCentre/basicInformation'
            },3000)
          })
        },
    }
</script>

<style>
  @import "emailFirstStep.css";
</style>
